import React, { useContext, useCallback } from 'react';
import { FormattedMessage } from 'react-intl';
import PropTypes from 'prop-types';
import { DropdownMenu } from 'ui-components/components/dropdown-menu';
import { DropdownMenuToggler } from 'ui-components/components/dropdown-menu-toggler';
import { DropdownMenuItem } from 'ui-components/components/dropdown-menu-item';
import messages from '../../messages';
import { AllocationRulesContext } from '../../context';
import { selectedMarketPlaceForFilterSet, getUpdatedCollectionFilter } from '../../rule-helper';

const MarketplaceMenu = ({ filterId }) => {
  const { marketPlaces, filterSets, persistUpdatedFilterSet } = useContext(AllocationRulesContext);
  const filterSet = filterSets[filterId];
  const selectedMarketplace = selectedMarketPlaceForFilterSet(filterSet, marketPlaces);

  const updateFilterSet = useCallback(
    (selectedMarketPlaceId) => {
      persistUpdatedFilterSet(getUpdatedCollectionFilter(selectedMarketPlaceId, filterSet));
    },
    [persistUpdatedFilterSet, filterSet],
  );

  return (
    <>
      <FormattedMessage {...messages.allocationStrategiesOrderMarketplace} values={{ b: () => undefined, storeName: undefined }} />
      <DropdownMenu>
        <DropdownMenuToggler>{selectedMarketplace?.name}</DropdownMenuToggler>
        {marketPlaces.map((mkt) => {
          return (
            <DropdownMenuItem key={mkt.marketplaceId} onClick={() => updateFilterSet(mkt.marketplaceId)}>
              {mkt.name}
            </DropdownMenuItem>
          );
        })}
      </DropdownMenu>
    </>
  );
};

MarketplaceMenu.propTypes = {
  filterId: PropTypes.number.isRequired,
};

export default MarketplaceMenu;
